<template>
  <div
    class="pointer-events-auto relative z-50 min-w-[300px] overflow-hidden rounded bg-canvas py-3 px-5 text-sm shadow-[0_6px_19px_0_rgba(182,182,182,0.35)]"
  >
    <div class="absolute top-0 left-0 h-full w-[5px] bg-primary"></div>

    <p class="font-normal text-primary">
      <NotificationTitle
        :title="notification.title"
        :link="notification.link"
      />
    </p>
    <p
      v-if="notification.description"
      class="font-semibold text-fg"
      v-text="notification.description"
    />
    <p v-if="notification.link && !useHasInlineLink(notification)">
      <a
        class="font-bold text-primary underline"
        :target="notification.link.target ?? '_blank'"
        :href="notification.link.href"
        >{{ notification.link.text }}</a
      >
    </p>
    <div class="flex justify-end gap-5 pt-3">
      <button
        type="button"
        class="text-xs font-medium text-gray-700 outline-none hover:text-gray-500 hover:underline"
        @click="emit('dismissed')"
        v-text="$t('common.dismiss')"
      />
    </div>
  </div>
</template>

<script setup>
import NotificationTitle from '@/Components/Notifications/NotificationTitle.vue'
import { useHasInlineLink } from '@/composables/notification'

defineProps({
  notification: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['dismissed'])
</script>
